/**
 * Hook to get the current trial period duration.
 * Fixed at 14 days - no longer dependent on feature flags.
 */
export const useTrialDays = () => {
  return { 
    trialDays: 14, 
    loading: false,
    isExtendedTrial: true 
  };
};
